import PageHeader from "@/components/PageHeader";

const sections = [
  {
    h: "1. Products and Inventory",
    p: [
      "Products sold by CNL Tech may be new, open-box, refurbished, or previously owned. Each listing reflects the product’s condition grade and any relevant notes.",
      "Product specifications, accessories, and packaging may vary between manufacturers, models, and individual units. Buyers should review each listing carefully prior to purchase.",
    ],
  },
  {
    h: "2. Compatibility",
    p: [
      "Customers are responsible for ensuring product compatibility with their existing setup, software, or accessories before completing a purchase.",
      "If you need help confirming compatibility, our customer support team is available during business hours to assist.",
    ],
  },
  {
    h: "3. Trademarks and Intellectual Property",
    p: [
      "All brand names, trademarks, logos, and product names referenced on this website are the property of their respective owners.",
      "Use of any third-party trademarks or names on this site is for descriptive purposes only and does not imply any endorsement or affiliation.",
    ],
  },
  {
    h: "4. Scope of Sale",
    p: [
      "CNL Tech sells hardware products only.",
      "CNL Tech does not provide, sell, or facilitate any form of subscription service, content service, broadcast service, software service, or media access. Customers seeking such services must obtain them independently from authorized providers.",
    ],
  },
  {
    h: "5. Customer Responsibilities",
    p: [
      "Customers are responsible for ensuring their use of purchased products complies with applicable laws, regulations, and the terms of any third-party service providers they may use.",
      "Purchases imply acceptance of the product as described in the listing, including its assigned condition grade.",
    ],
  },
  {
    h: "6. Returns and Resolution",
    p: [
      "Return policies and warranties vary by product and are described on each listing. If a product arrives damaged or significantly different from its description, contact our support team for assistance.",
      "CNL Tech will work toward a fair resolution within the scope of the listing and condition grade.",
    ],
  },
  {
    h: "7. Limitation of Liability",
    p: [
      "To the maximum extent permitted by applicable law, CNL Tech is not liable for indirect, incidental, or consequential damages arising from the use or inability to use any product purchased from us.",
    ],
  },
  {
    h: "8. Changes to These Terms",
    p: [
      "CNL Tech may update these terms from time to time to reflect changes in operations, technology, or law. Material changes will be posted on this page.",
    ],
  },
];

export default function Legal() {
  return (
    <div data-testid="legal-page">
      <PageHeader
        eyebrow="Legal"
        breadcrumb="Terms of Service"
        title="Terms of Service & Disclaimer"
        subtitle="Please review the following terms carefully. By using this website or purchasing from CNL Tech, you agree to these terms."
      />

      <section className="bg-white">
        <div className="cnl-container py-20 lg:py-24 grid lg:grid-cols-12 gap-12">
          <aside className="lg:col-span-3">
            <div className="lg:sticky lg:top-28">
              <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#2563EB]">
                On This Page
              </span>
              <ul className="mt-4 space-y-2 text-[13.5px] text-gray-700">
                {sections.map((s, i) => (
                  <li key={s.h}>
                    <a
                      href={`#section-${i + 1}`}
                      className="hover:text-[#0B192C] transition-colors"
                    >
                      {s.h}
                    </a>
                  </li>
                ))}
              </ul>
              <p className="mt-8 text-[12px] text-gray-500 leading-relaxed">
                Last updated: {new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" })}
              </p>
            </div>
          </aside>

          <div className="lg:col-span-9 space-y-10 text-[15px] leading-relaxed text-gray-700">
            {sections.map((s, i) => (
              <article id={`section-${i + 1}`} key={s.h} className="scroll-mt-28">
                <h2 className="text-[22px] font-bold tracking-tight text-[#0B192C]">
                  {s.h}
                </h2>
                <div className="mt-4 space-y-4">
                  {s.p.map((para, j) => (
                    <p key={j}>{para}</p>
                  ))}
                </div>
              </article>
            ))}

            <div className="mt-8 border border-gray-200 rounded-sm bg-[#F9FAFB] p-6">
              <h3 className="text-[15px] font-semibold uppercase tracking-[0.16em] text-[#1E3E62]">
                Questions about these terms?
              </h3>
              <p className="mt-2 text-[14px] text-gray-600">
                Contact us at{" "}
                <a href="mailto:cnltech@proton.me" className="cnl-link font-semibold">
                  cnltech@proton.me
                </a>{" "}
                or visit the Contact page.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
